import { render } from "./Welcome-view.vue?vue&type=template&id=1444dfc7"
import script from "./Welcome-view.vue?vue&type=script&lang=js"
export * from "./Welcome-view.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__